import { useState } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const faqs = [
    {
      question: 'What is Epoch7 Software/Tool?',
      answer:
        'Every organization has several functional units, and teams that need to work in coordination to produce the outcomes to achieve the organization’s objectives.',
    },
    {
      question: 'Why should your organization use Epoch7 software?',
      answer:
        'Yes, our platform is fully customizable to meet the specific needs of your business.',
    },
    {
      question: 'Why is Epoch7 tool better than spreadsheets or generic tools?',
      answer: 'Absolutely! We offer 24/7 customer support to ensure your business runs smoothly.',
    },
    {
      question: 'How to choose the right Epoch7 Software for your needs?',
      answer: 'Absolutely! We offer 24/7 customer support to ensure your business runs smoothly.',
    },
    {
      question: 'What are the key features to look for in Epoch7?',
      answer: 'Absolutely! We offer 24/7 customer support to ensure your business runs smoothly.',
    },
  ]

  return (
    <section className="faqs-section pad-60">
      <div className="container">
        <Typography variant="h3" className="mb-4">
          Frequently Asked Questions
        </Typography>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={activeIndex === index}
              onChange={() => setActiveIndex(activeIndex === index ? null : index)}
              sx={{
                mb: 1,
                borderBottom: 'none',
                backgroundColor: 'transparent', // No background color
                boxShadow: 'none', // No box shadow
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{ borderBottom: 'none', marginBottom: '0px' }}
              >
                <div className="faq-list">
                  <div className="faq-item">
                    <div className="faq-question">
                      <Typography variant="h4">{faq.question}</Typography>
                    </div>
                  </div>
                </div>
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  maxHeight: activeIndex === index ? '500px' : '0', // Control max height for smooth opening/closing
                  overflow: 'hidden',
                  transition: 'max-height 0.3s ease-in-out', // Smooth transition of the content area
                  padding: '16px', // Adjust padding if needed
                }}
              >
                <Typography>{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQs
